/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.visflux.chord

import com.macrofocus.common.properties.MutableProperty
import org.mkui.canvas.Rendering
import org.mkui.component.CPComponentProvider
import org.mkui.component.CPInteractiveComponent
import org.mkui.graphics.colortheme.ColorTheme

/** A chord diagram: the nodes on a circle, linked by ribbons whose width is the weight of their links. */
interface ChordView<Node, Link> : CPComponentProvider, CPInteractiveComponent {
    enum class PropertyType {
        ShowFiltered, Antialiasing, Rendering, ColorTheme, Twisted, Geometry, OuterRadius, InnerRadius
    }

    enum class Geometry {
        Straight, Curved
    }

    var model: ChordModel<Node, Link, *>?

    val showFiltered: MutableProperty<Boolean>
    val antialiasing: MutableProperty<Boolean>
    val rendering: MutableProperty<Rendering>
    val colorTheme: MutableProperty<ColorTheme>
    val geometry: MutableProperty<Geometry>
    val twisted: MutableProperty<Boolean>
    val outerRadius: MutableProperty<Double>
    val innerRadius: MutableProperty<Double>

    /** The node whose arc (with its padding) is at the angle of a point, or null. */
    fun getClosestNode(x: Int, y: Int): Node?
}
